import '../../userStyle.scss';

import { Col, Dropdown, Form, Menu, message } from 'antd';
import { DownOutlined, EnvironmentOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';

import CheckBox from 'src/assets/img/SalesForce_Icon/CheckBox.svg';
import TextComponent from '@sharedComponent/typography/TextComponent';

const SalesForceCheckBox = ({ isChecked, text, onCheck, setIsDisabled, force = false }) => {
	const [selected, setSelected] = useState(isChecked);

	useEffect(() => {
		if (force === true) {
			setSelected(isChecked);
		}
	}, [isChecked]);

	const checking = (value) => {
		setSelected(value);
		onCheck(value);
		setIsDisabled(value);
	};
	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
				<div style={{ marginRight: '8px' }}>
					{selected ? (
						<img onClick={() => checking(false)} className="selected_radio_button_style" src={CheckBox}></img>
					) : (
						<input style={{ marginTop: '5px' }} className="radio_button_style" type="radio" onClick={() => checking(true)} />
					)}
				</div>
				<TextComponent className={selected ? 'option_text_selected' : 'option_text_un_selected'}>
					<p style={{ margin: 0 }}>{text}</p>
				</TextComponent>
			</div>
		</>
	);
};

export default SalesForceCheckBox;
